export default "__VITE_ASSET__jF$eMVNx__"